import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { ROLE, RenderEmailOrNameUserDisplay } from './constants';
import { AvatarUser } from 'components/common';

export default function User({
    dataParticipant,
    setChangeDataParticipant,
    index,
    OperatorRole,
    displayCloseIcon = true,
}) {
    const handleChangeDataParticipant = (value, isDeleted = false) => {
        setChangeDataParticipant({
            username: dataParticipant?.username,
            name: dataParticipant?.name,
            role: value,
            isDeleted: isDeleted,
            idAccount: dataParticipant?.accId,
        });
    };

    const convertRoleOwnerAndHostAndCoHostToString = (role) => {
        if (role === ROLE.HOST) {
            return t('modalDetail.roleUser.host');
        } else if (role === ROLE.OWNER) {
            return t('modalDetail.roleUser.owner');
        } else {
            return t('modalDetail.roleUser.coHost');
        }
    };

    const hasOperatorRole = () => {
        return (
            dataParticipant?.role === ROLE.OWNER ||
            dataParticipant?.participantType === ROLE.OWNER ||
            dataParticipant?.role === ROLE.HOST ||
            dataParticipant?.participantType === ROLE.HOST ||
            dataParticipant?.role === ROLE.CO_HOST ||
            dataParticipant?.participantType === ROLE.CO_HOST
        );
    };

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative', padding: '10px 0 0 12px' }}>
                <AvatarUser user={dataParticipant} hasWrapper={true}/>
                <Box
                    sx={
                        OperatorRole
                            ? {
                                  borderLeftColor: 'transparent !important',
                                  border: theme => `1px solid ${theme.palette.ui.border}`,
                                  padding: '0 36px 0 8px',
                                  borderRadius: '0 30px 30px 0',
                                  minHeight: '40px',
                                  maxWidth: '178px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'start',
                              }
                            : {
                                  borderLeftColor: 'transparent !important',
                                  border: theme => `1px solid ${theme.palette.ui.border}`,
                                  padding: '0 36px 0 8px',
                                  borderRadius: '0 30px 30px 0',
                                  minHeight: '40px',
                                  display: 'flex',
                                  flexDirection: hasOperatorRole() ? 'column' : 'row',
                                  alignItems: hasOperatorRole() ? 'start' : 'center',
                              }
                    }
                >
                    <Box>
                        <RenderEmailOrNameUserDisplay
                            name={dataParticipant?.name || ''}
                            email={dataParticipant?.email}
                        />
                    </Box>
                    {hasOperatorRole() && (
                        <Typography sx={{ fontSize: '12px', color: '#949595' }}>
                            {convertRoleOwnerAndHostAndCoHostToString(
                                dataParticipant?.role || dataParticipant?.participantType,
                            )}
                        </Typography>
                    )}
                </Box>
                {displayCloseIcon && (
                    <CloseRoundedIcon
                        sx={{
                            position: 'absolute',
                            right: '4px',
                            maxHeight: '14px',
                            cursor: 'pointer',
                            color: '#CB002B',
                        }}
                        onClick={() => handleChangeDataParticipant('', true)}
                    />
                )}
            </Box>
        </>
    );
}
